const initShareLinks = () => {
  document.querySelectorAll('[data-share-copy]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()

      const url = link.getAttribute('href') || window.location.href

      const markCopied = () => {
        link.classList.add('is-copied')
        window.setTimeout(() => link.classList.remove('is-copied'), 1200)
      }

      const fallbackCopy = () => {
        try {
          const input = document.createElement('input')
          input.value = url
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          input.remove()
          markCopied()
        } catch (error) {
          window.open(url, '_blank', 'noopener,noreferrer')
        }
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(markCopied).catch(fallbackCopy)
        return
      }

      fallbackCopy()
    })
  })
}

export default initShareLinks



// WEBPACK FOOTER //
// ./resources/assets/js/components/share-links.js